import React from 'react';
import { HeroBanner } from '../components/HeroBanner';
import { SocialProofBar } from '../components/home/SocialProofBar';
import { TodayInSky } from '../components/home/TodayInSky';
import { HowItWorks } from '../components/home/HowItWorks';
import { PopularServices } from '../components/home/PopularServices';
import { WhyAstroGuide } from '../components/home/WhyAstroGuide';
import { PricingSection } from '../components/home/PricingSection';
import { ReportPreviewSection } from '../components/home/ReportPreviewSection';
import { TopAstrologersSection } from '../components/home/TopAstrologersSection';
import { AstroCalendarSection } from '../components/home/AstroCalendarSection';
import { BlogSection } from '../components/home/BlogSection';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { ForAstrologersSection } from '../components/home/ForAstrologersSection';
import { FaqSection } from '../components/home/FaqSection';
import { FinalCtaSection } from '../components/home/FinalCtaSection';
import { SectionErrorBoundary } from '../components/SectionErrorBoundary';
interface HomePageProps {
  onNavigate: (page: string) => void;
}
export function HomePage({
  onNavigate
}: HomePageProps) {
  return <div className="w-full" data-id="element-23894">
      {/* 1. HERO */}
      <SectionErrorBoundary sectionName="HeroBanner" fallbackMinHeight="min-h-screen" data-id="element-23895">
        <HeroBanner onNavigate={onNavigate} data-id="element-23896" />
      </SectionErrorBoundary>

      {/* 2. SOCIAL PROOF BAR */}
      <SectionErrorBoundary sectionName="SocialProofBar" fallbackMinHeight="min-h-[80px]" data-id="element-23897">
        <SocialProofBar data-id="element-23898" />
      </SectionErrorBoundary>

      {/* 3. СЕГОДНЯ В НЕБЕ */}
      <SectionErrorBoundary sectionName="TodayInSky" data-id="element-23899">
        <TodayInSky onNavigate={onNavigate} data-id="element-23900" />
      </SectionErrorBoundary>

      {/* 4. КАК ЭТО РАБОТАЕТ */}
      <SectionErrorBoundary sectionName="HowItWorks" data-id="element-23901">
        <HowItWorks data-id="element-23902" />
      </SectionErrorBoundary>

      {/* 5. ПОПУЛЯРНЫЕ УСЛУГИ */}
      <SectionErrorBoundary sectionName="PopularServices" data-id="element-23903">
        <PopularServices onNavigate={onNavigate} data-id="element-23904" />
      </SectionErrorBoundary>

      {/* 6. ПОЧЕМУ ASTRIQO */}
      <SectionErrorBoundary sectionName="WhyAstroGuide" data-id="element-23905">
        <WhyAstroGuide data-id="element-23906" />
      </SectionErrorBoundary>

      {/* 7. ТАРИФЫ */}
      <SectionErrorBoundary sectionName="PricingSection" data-id="element-23907">
        <PricingSection onNavigate={onNavigate} data-id="element-23908" />
      </SectionErrorBoundary>

      {/* 8. ПРЕВЬЮ ОТЧЁТА */}
      <SectionErrorBoundary sectionName="ReportPreviewSection" data-id="element-23909">
        <ReportPreviewSection onNavigate={onNavigate} data-id="element-23910" />
      </SectionErrorBoundary>

      {/* 9. ТОП АСТРОЛОГИ */}
      <SectionErrorBoundary sectionName="TopAstrologersSection" data-id="element-23911">
        <TopAstrologersSection onNavigate={onNavigate} data-id="element-23912" />
      </SectionErrorBoundary>

      {/* 10. КАЛЕНДАРЬ */}
      <SectionErrorBoundary sectionName="AstroCalendarSection" data-id="element-23913">
        <AstroCalendarSection onNavigate={onNavigate} data-id="element-23914" />
      </SectionErrorBoundary>

      {/* 11. БЛОГ */}
      <SectionErrorBoundary sectionName="BlogSection" data-id="element-23915">
        <BlogSection onNavigate={onNavigate} data-id="element-23916" />
      </SectionErrorBoundary>

      {/* 12. ОТЗЫВЫ */}
      <SectionErrorBoundary sectionName="ReviewsSection" data-id="element-23917">
        <ReviewsSection data-id="element-23918" />
      </SectionErrorBoundary>

      {/* 13. ДЛЯ АСТРОЛОГОВ */}
      <SectionErrorBoundary sectionName="ForAstrologersSection" data-id="element-23919">
        <ForAstrologersSection onNavigate={onNavigate} data-id="element-23920" />
      </SectionErrorBoundary>

      {/* 14. FAQ */}
      <SectionErrorBoundary sectionName="FaqSection" data-id="element-23921">
        <FaqSection data-id="element-23922" />
      </SectionErrorBoundary>

      {/* 15. ФИНАЛЬНЫЙ CTA */}
      <SectionErrorBoundary sectionName="FinalCtaSection" data-id="element-23923">
        <FinalCtaSection data-id="element-23924" />
      </SectionErrorBoundary>
    </div>;
}